import axios from './configAxios';

export const delGroupApi = async (group_id) => {
	return axios.delete(`${group_id}/delete/`);
};
